/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum RewardTypes {
    Pplns = 'Pplns',
    Fpps = 'Fpps',
    Prop = 'Prop',
    Pps = 'Pps'
}

